import { api } from './client';

const base = (slug: string) => `/trips/${encodeURIComponent(slug)}/api`;

export interface ActAggregate {
  avg: number;
  count: number;
}

export interface MyRating {
  stars: number;
  comment: string;
  updatedAt: string;
}

export interface RatingsBulkResponse {
  byAct: Record<string, ActAggregate>;
  mine: Record<string, MyRating>;
}

export interface ActRatingEntry {
  name: string;
  stars: number;
  comment: string;
  updatedAt: string;
}

export interface ActRatingsDetail {
  avg: number;
  count: number;
  ratings: ActRatingEntry[];
}

export interface PostRatingInput {
  actId: string;
  stars: number;
  comment?: string;
}

export interface PostRatingResponse {
  ok: true;
  isUpdate: boolean;
  stars: number;
  comment: string;
  updatedAt: string;
}

export function fetchRatings(slug: string, signal?: AbortSignal): Promise<RatingsBulkResponse> {
  return api.get<RatingsBulkResponse>(`${base(slug)}/ratings`, { signal });
}

export function fetchActRatings(slug: string, actId: string, signal?: AbortSignal): Promise<ActRatingsDetail> {
  return api.get<ActRatingsDetail>(`${base(slug)}/ratings/${encodeURIComponent(actId)}`, { signal });
}

export function postRating(slug: string, input: PostRatingInput): Promise<PostRatingResponse> {
  return api.post<PostRatingResponse>(`${base(slug)}/ratings`, input);
}
